import { registerPlugin } from '@capacitor/core';
const CapacitorForegroundService = registerPlugin('CapacitorForegroundService', {
    web: () => import('./web').then(m => new m.CapacitorForegroundServiceWeb()),
});
export * from './definitions';
export { CapacitorForegroundService };
//# sourceMappingURL=index.js.map